<template>
  <field-container
    :label="label"
    :required="required"
  >
    <form-thum-files
      :name="name"
      :error="error"
      :url="url"
      :uuid="uuid"
      :files="files"
      :readonly="readonly"
      :helpText="helpText"
      :helpHtml="helpHtml"
      :limit="limit"
      :accept="accept"
      :uploadStatus="uploadStatus"
      @removeFile="(value) => $emit('removeFile', value)"
      @error="(value) => $emit('error', value)"
      @fileUpload="(value) => $emit('fileUpload', value)"
    ></form-thum-files>
  </field-container>
</template>

<script>
export default {
  props: {
    label: { type: String, required: true },
    name: { type: String, required: true },
    error: { type: Object, required: true },
    url: { type: String, required: true },
    uuid: { type: String, required: true },
    files: { type: Array, required: true },
    readonly: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    helpText: { type: String, default: '' },
    helpHtml: { type: String, default: '' },
    limit: { type: Number, default: 1 },
    uploadStatus: { type: String, default: '' },
    accept: { type: Array }
  },
  methods: {
    onFileError (err) {
      console.log('err1111', err)
    },
    onFileUpload (uploadStatus) {
      this.$emit('fileUpload', uploadStatus)
    }
  },
  components: {
    FormThumFiles: () => import('@/component/ui2/form/FormThumFiles'),
    FieldContainer: () => import('@/component/ui2/uicontainer/FieldContainer')
  }
}
</script>
